export default "__VITE_ASSET__woZgC7Qx__"